import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CookieService } from 'ngx-cookie-service';

import {
  GastCommonNgModule, HttpService, selectEnvironmentFile, StorageService, CustomTranslateHttpLoader,
  TranslationService, CommonService, PortalHttpErrorInterceptor
} from 'gast-common-ng';
import { GastPortalNgModule, AuthService, UrlParamService, HttpAuthHeaderInterceptor } from 'gast-portal-ng';
import { GastOnsetNgModule } from 'gast-onset-ng';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { UrlService } from './shared/services/common/url.service';
import { AuthGuard } from './shared/services/common/auth-guard.service';
import { BookingStepService } from './shared/services/booking-step.service';
import { ShoppingCartService } from './shared/services/shopping-cart.service';
import { HeaderService } from './shared/services/header.service';
import {SafeHtmlPipe} from './shared/pipes/safe-html.pipe';

registerLocaleData(localeDe);


// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  const urls: Array<string> = [
    './common-assets/i18n/',
    './portal-assets/i18n/',
    './assets/i18n/'
  ];
  return new CustomTranslateHttpLoader(httpClient, urls, '.json');
}

export function TranslationServiceFactory(translationService: TranslationService) {
  return translationService;
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxDatatableModule,
    ToastrModule.forRoot(),
    GastPortalNgModule.forRoot({
      provide: TranslationService,
      useFactory: TranslationServiceFactory,
      deps: [TranslateService]
    }),
    GastCommonNgModule.forRoot(),
    GastOnsetNgModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxSpinnerModule,
  ],
  providers: [
    HttpService,
    TranslationService,
    StorageService,
    CommonService,
    AuthService,
    UrlParamService,
    UrlService,
    AuthGuard,
    BookingStepService,
    ShoppingCartService,
    HeaderService,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthHeaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PortalHttpErrorInterceptor,
      multi: true,
    },
    {
      provide: 'env',
      useValue: { callback: selectEnvironmentFile, value: environment.envName }
    }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
